import { ChevronDown, Loader2 } from 'lucide-react';
import { getTreeItemPadding } from './types';

interface LoadMoreButtonProps {
  depth: number;
  isLoading: boolean;
  loadedCount: number;
  totalCount?: number;
  onClick: () => void;
}

export function LoadMoreButton({
  depth,
  isLoading,
  loadedCount,
  totalCount,
  onClick,
}: LoadMoreButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isLoading}
      className="flex w-full items-center gap-1.5 rounded py-1.5 text-xs text-primary hover:bg-accent/50 active:bg-accent transition-all disabled:opacity-70 group"
      style={getTreeItemPadding(depth)}
    >
      {isLoading ? (
        <>
          <Loader2 className="h-3 w-3 shrink-0 animate-spin" />
          <span className="text-muted-foreground">Loading...</span>
        </>
      ) : (
        <>
          <ChevronDown className="h-3 w-3 shrink-0 transition-transform group-hover:translate-y-0.5" />
          <span className="group-hover:underline">
            Load more
            <span className="ml-1 text-muted-foreground">
              ({loadedCount} of {totalCount ?? '?'})
            </span>
          </span>
        </>
      )}
    </button>
  );
}
